import { createModel, Models } from '@rematch/core'
import _ from 'lodash'

export interface SsrRootModel extends Models<SsrRootModel> {
    ssrModel: typeof ssrModel
}



export const ssrModel =  createModel<SsrRootModel>()({
    state: {},
    reducers: {
        setInitialProps(state, payload: Record<string, any>) {
            return {
                ...state,
                ...payload
            }
        },
        cleanInitialProps(state, propsID) {
            if (!_.has(state, propsID)) throw new Error(`ssrModel does't have ${propsID} `)
            return {
                ...state,
                [propsID]: {}
            }
        },

    }
})

